module.exports = __webpack_public_path__ + "img/store-play-en.4539f1c.png";